import React, { Component } from 'react'
import './App.css'
import './Login.css'
import { Link, withRouter, Redirect } from 'react-router-dom'
import axios from 'axios'
import ClipLoader from 'react-spinners/ClipLoader'
import { FaCheck } from 'react-icons/fa'
import { MdClose } from 'react-icons/md'
import { API_URL } from './config'

class Login extends Component {
  constructor(props) {
    super(props)

    this.state = {
      email: '',
      password: '',
      error: '',
      errorDisplay: false,
      spinning: false,
      optionOne: false,
    }
  }

  componentDidMount() {
    document.title = 'Karamale - Log in or sign up'
    localStorage.removeItem('partner')
  }

  handleEmail = (event) => {
    this.setState({
      email: event.target.value,
      error: '',
      errorDisplay: false,
    })
  }

  handlePassword = (event) => {
    this.setState({
      password: event.target.value,
      error: '',
      errorDisplay: false,
    })
  }

  existingAudience = (event) => {
    const checked = event.target.checked

    this.setState({
      optionOne: checked,
    })

    if (checked) {
      localStorage.setItem('partner', 'yes')
    } else {
      localStorage.removeItem('partner')
    }
  }

  submitLogin = async (event) => {
    event.preventDefault()

    const { email, password, optionOne } = this.state

    if (!email.trim()) {
      this.setState({ error: 'Please enter your email address.', errorDisplay: true })
      return
    }
    if (!password) {
      this.setState({ error: 'Please enter your password.', errorDisplay: true })
      return
    }

    this.setState({ spinning: true, error: '', errorDisplay: false })

    const formData = new FormData()
    formData.append('email', email.trim())
    formData.append('password', password)
    formData.append('os', navigator.platform)
    formData.append('partner', optionOne ? 'yes' : 'no')

    try {
      const response = await axios.post(`${API_URL}/apps/kscanner/loginWeb.php`, formData, {
        withCredentials: true,
      })

      const data = response.data || {}
      const payload = data.data || {}

      const message = String(data.message || '').toLowerCase()
      const type = String(payload.account_type || '').toLowerCase()

      const id = payload.account_id || ''
      const name = payload.account_name || ''
      const mail = email.trim()

      const finish = (accountType, path, values) => {
        localStorage.clear()
        localStorage.setItem('accounttype', accountType)
        Object.entries(values).forEach(([k, v]) => localStorage.setItem(k, v ?? ''))
        this.setState({ spinning: false, error: '', errorDisplay: false })
        window.location.href = path
      }

      if (
        data.status === 'success' &&
        (type === 'customer' || message.includes('customer login'))
      ) {
        return finish('customer', '/customerdashboard', {
          customerid: id,
          customername: name,
          customeremail: mail,
        })
      }

      if (
        data.status === 'success' &&
        (type === 'business' || message.includes('business login'))
      ) {
        return finish('business', '/dashboard', {
          businessid: id,
          businessname: name,
          businessemail: mail,
        })
      }

      if (data.status === 'success' && (type === 'partner' || message.includes('partner login'))) {
        return finish('partner', '/in', {
          partner: 'yes',
          partnerid: id,
          partnername: name,
        })
      }

      this.setState({
        spinning: false,
        error: data.message || data.error || 'The email or password you entered is incorrect.',
        errorDisplay: true,
      })
    } catch (error) {
      this.setState({
        spinning: false,
        error:
          error.response?.data?.message ||
          error.response?.data?.error ||
          'Something went wrong. Please try again.',
        errorDisplay: true,
      })
    }
  }

  render() {
    const { email, password, error, errorDisplay, spinning, optionOne } = this.state

    if (localStorage.getItem('customername')) {
      return <Redirect to="/customerdashboard" />
    }

    return (
      <div className="kx-login-page">
        <div className="kx-login-bg">
          <div className="kx-login-bg__orb kx-login-bg__orb--one"></div>
          <div className="kx-login-bg__orb kx-login-bg__orb--two"></div>
          <div className="kx-login-bg__grid"></div>
          <div className="kx-login-bg__word">KARAMALE</div>
        </div>

        <main className="kx-login">
          <div className="kx-login__wrap">
            <section className="kx-login__brand">
              <Link to="/" className="kx-login__logo">
                karamale<span>.</span>
              </Link>

              <div className="kx-login__brand-content">
                <div className="kx-login__eyebrow">THE EVENT PLATFORM</div>

                <h1>
                  Your events.
                  <br />
                  <strong>Your audience.</strong>
                  <br />
                  One platform.
                </h1>

                <p>
                  Discover events, manage your tickets and stay connected with everything happening
                  around you.
                </p>

                <div className="kx-login__brand-points">
                  <div className="kx-login__brand-point">
                    <span>
                      <FaCheck />
                    </span>
                    Discover events
                  </div>

                  <div className="kx-login__brand-point">
                    <span>
                      <FaCheck />
                    </span>
                    Secure ticketing
                  </div>

                  <div className="kx-login__brand-point">
                    <span>
                      <FaCheck />
                    </span>
                    Built for organisers
                  </div>
                </div>
              </div>

              <div className="kx-login__brand-footer">
                <span>© {new Date().getFullYear()} Karamale</span>
                <span>Events made simple.</span>
              </div>
            </section>

            <section className="kx-login__panel">
              <div className="kx-login__card">
                <div className="kx-login__card-head">
                  <span className="kx-login__card-kicker">WELCOME BACK</span>

                  <h2>Log in to Karamale</h2>

                  <p>Access your account and continue where you left off.</p>
                </div>

                {errorDisplay && (
                  <div className="kx-login__error">
                    <span className="kx-login__error-icon">
                      <MdClose />
                    </span>

                    <span>{error}</span>
                  </div>
                )}

                <form className="kx-login__form" onSubmit={this.submitLogin}>
                  <div className="kx-login__field">
                    <label htmlFor="login-email">Email address</label>

                    <input
                      id="login-email"
                      type="email"
                      value={email}
                      onChange={this.handleEmail}
                      placeholder="you@example.com"
                      autoComplete="email"
                      disabled={spinning}
                    />
                  </div>

                  <div className="kx-login__field">
                    <div className="kx-login__field-label">
                      <label htmlFor="login-password">Password</label>

                      <Link to="/password">Forgot password?</Link>
                    </div>

                    <input
                      id="login-password"
                      type="password"
                      value={password}
                      onChange={this.handlePassword}
                      placeholder="Enter your password"
                      autoComplete="current-password"
                      disabled={spinning}
                    />
                  </div>

                  <label className="kx-login__partner">
                    <input
                      type="checkbox"
                      checked={optionOne}
                      onChange={this.existingAudience}
                      disabled={spinning}
                    />

                    <span className="kx-login__checkbox">{optionOne && <FaCheck />}</span>

                    <span>I am an existing Karamale partner</span>
                  </label>

                  <button type="submit" className="kx-login__submit" disabled={spinning}>
                    {spinning ? (
                      <>
                        <ClipLoader size={18} color="#ffffff" loading={true} />

                        <span>Signing in...</span>
                      </>
                    ) : (
                      <>
                        <span>Log in</span>

                        <span className="kx-login__submit-arrow">→</span>
                      </>
                    )}
                  </button>
                </form>

                <div className="kx-login__register">
                  <span className="kx-login__register-label">NEW TO KARAMALE?</span>

                  <Link to="/registration" className="kx-login__register-link">
                    <span>Create an account</span>

                    <span className="kx-login__register-arrow">→</span>
                  </Link>
                </div>

                <div className="kx-login__card-footer">
                  <Link to="/">← Back to Karamale</Link>
                </div>
              </div>
            </section>
          </div>
        </main>
      </div>
    )
  }
}

export default withRouter(Login)
